import {WBSelect} from '@wandb/weave/common/components/WBSelect';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const PageSizeSelectWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  margin-right: 4px;
`;

export const PageSizeSelect = styled(WBSelect)`
  margin-right: 6px;
  padding: 0;
`;
